export type ShadowRenderMenu =
  | boolean
  | undefined
  | (() => boolean | undefined);

export function shouldShadowRender(
  shadowRenderMenu: ShadowRenderMenu,
  isMeasured: any
): boolean | undefined {
  return (
    isMeasured === false && getShadowRenderMenuValue(shadowRenderMenu) !== false
  );
}

export function getShadowRenderMenuValue(
  shadowRenderMenu: ShadowRenderMenu
): boolean | undefined {
  return typeof shadowRenderMenu === "function"
    ? shadowRenderMenu()
    : shadowRenderMenu;
}
